import { Link } from "react-router-dom";
import menuOnClick from "../menuOnClick";

const MFooter = () => {
  return (
    <footer className="z-0 relative w-full h-full px-[calc((100%-var(--container))/2)] bg-[#181818] text-white pb-28 md:pb-36">
      <div className="relative w-full h-fit max-w-[var(--container-width)] mx-auto py-16">
        <div className=" relative w-fit h-full mx-auto">
          <img
            alt="하수구원킬케어 로고"
            src={"/images/logo.png"}
            className=" relative w-auto h-full max-h-10 lg:max-h-14 object-contain"
          />
        </div>
        <div className=" relative w-full h-fit flex flex-wrap justify-center items-center gap-x-3 gap-y-2 lg:gap-7 my-10">
          <span
            onClick={() => menuOnClick("#about")}
            className="opacity-70 hover:opacity-100"
          >
            <small>회사소개</small>
          </span>
          <small>|</small>
          <span
            onClick={() => menuOnClick("#service")}
            className="opacity-70 hover:opacity-100"
          >
            <small>서비스안내</small>
          </span>
          <small>|</small>
          <span
            onClick={() => menuOnClick("#blog")}
            className="opacity-70 hover:opacity-100"
          >
            <small>작업사례</small>
          </span>
          <small>|</small>
          <span
            onClick={() => menuOnClick("#contact")}
            className="opacity-70 hover:opacity-100"
          >
            <small>문의하기</small>
          </span>
        </div>
        <div className="flex justify-center items-center gap-2 mb-2 lg:mb-0 lg:gap-5 flex-wrap lg:flex-nowrap opacity-90">
          <small className="font-bold">하수구원킬케어</small>
          <small>|</small>
          <small>대표자: 한희선</small>
          <small>|</small>
          <small>전화: 010-8123-8285</small>
          <small>|</small>
          {/* <small>이메일: </small>
          <small>|</small> */}
          <small>사업자정보: 191-10-02787</small>
        </div>
        {/*<div className="flex justify-center items-center gap-2 lg:gap-5 flex-wrap lg:flex-nowrap opacity-90 mt-3 mb-3">*/}
        {/*  /!* <small>|</small> *!/*/}
        {/*  <small>주소: 경기도 수원시 장안구 율전로101번길 73</small>*/}
        {/*</div>*/}
        <div className="lg:flex justify-center items-center gap-2 text-center lg:text-left opacity-90">
          <small>
            COPYRIGHT 하수구원킬케어. <br className="block lg:hidden" /> ALL
            RIGHTS RESERVED. DESIGN BY [SMILEEAN]
          </small>
          <br className="block lg:hidden" />
          <Link
            to={"/admin/login"}
            className=" relative w-fit h-fit text-xs py-0.5 px-3 mt-2 lg:mt-0 border rounded-md hover:bg-white hover:text-black"
          >
            <small>관리자</small>
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default MFooter;
